import React from 'react'
import Grid from '@mui/material/Grid';

function FormAction({children,gap=1,sx={}}) {
  return (
    <Grid item container gap={gap} xs={12} sx={{justifyContent:'flex-end',...sx}}>
         {children}
   </Grid>

  )
}

export default FormAction